// src/components/Layout/Footer.js
import React from "react";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="p-4 bg-white border-t border-gray-200">
      <div className="text-center text-sm text-gray-500">
        <p>&copy; {year} Visualization App. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
